import { render, staticRenderFns } from "./RegistrationGstToggle.vue?vue&type=template&id=64e456af&scoped=true&"
import script from "./RegistrationGstToggle.vue?vue&type=script&lang=js&"
export * from "./RegistrationGstToggle.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationGstToggle.vue?vue&type=style&index=0&id=64e456af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e456af",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
